// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import LinkLabelContainerTemplate from '@front/templates/LinkLabelContainerTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { ContainerControl } from './ContainerControl';
/**
 * LinkLabelContainer class handles the display (in a row) and management of multiple link labels.
 */
export class LinkLabelContainer extends ContainerControl {
    /**
     * Returns the control type.
     * @returns {string} The control type.
     */
    getType() {
        return ControlsTypes.LinkLabelContainer;
    }
    constructor() {
        super();
    }
    /**
     * Initializes the component and sets up event handlers.
     * Observes changes to the 'links' property and updates accordingly.
     */
    oninit() {
        super.oninit();
        // Handle the 'linkClick' event and propagate it to the parent component
        this.on('linkClick', (sender) => {
            this.fire('onLinkClick', sender);
        });
        // Observe changes to the 'links' data and process them when updated
        this.observe('links', (newLinks) => {
            this.updateLinks(newLinks);
        });
    }
    /**
     * Updates the 'links' property with the provided data.
     * Ensures that each link has valid 'linkHref' before updating the state.
     * @param {Array} newLinks - The new list of link data to be processed.
     */
    updateLinks(newLinks) {
        const filteredLinks = newLinks.filter((link) => isValidURL(link.linkHref));
        void this.set({ links: filteredLinks });
    }
    /**
     * Adds a new link to the 'links' data.
     * @param {Object} linkData - The link data to be added.
     * @param {string} linkData.text - The link's display text.
     * @param {string} linkData.linkHref - The URL the link points to.
     * @param {string} [linkData.tooltip] - Optional tooltip text for the link.
     * @param {string} [linkData.name] - Optional name for the link.
     */
    addLink(linkData) {
        const links = this.get('links') || [];
        links.push(linkData);
        void this.set({ links });
    }
}
ContainerControl.extendWith(LinkLabelContainer, {
    template: LinkLabelContainerTemplate,
    data: function () {
        return {
            links: [],
            tooltips: []
        };
    }
});
